import script from "./passCode.vue?vue&type=script&setup=true&lang=js"
export * from "./passCode.vue?vue&type=script&setup=true&lang=js"

import "./passCode.vue?vue&type=style&index=0&id=d8240fd2&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8240fd2"]])

export default __exports__